<p-floatlabel [variant]="variant">
  <p-iconfield>
    <p-inputicon styleClass="pi pi-search" />
    <p-autocomplete
      [inputId]="id"
      [formControl]="control"
      [suggestions]="filteredItems ?? []"
      (completeMethod)="filter($event)"
      optionValue="id"
      optionLabel="label"
      [dropdown]="false"
      [completeOnFocus]="true"
      [showClear]="true"
    />
  </p-iconfield>
  @if (hasLabel()) {
    <label [for]="id">{{ label }}</label>
  }
</p-floatlabel>
@if (showError) {
  <small class="autocomplete__error">{{ errorMessage ?? 'This field is required' }}</small>
}
